import * as axios from 'axios';
import * as utils from '../shared/service-utils';

import { API } from '../shared/config';

export default {
  methods: {
    async getBillStatusData() {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/bill-statuses`, { headers: hdr });
        return response.data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
  },
};
